// @flow
import PropTypes from 'prop-types';
import * as React from 'react';

import { mountModal } from 'lib/modal';
import AppLayoutContentView from 'app/components/AppLayoutContentView';
import AppLayoutContentViewHeader from 'app/components/AppLayoutContentViewHeader';
import ConfirmDialog from 'components/ConfirmDialog';
import CurrentUser from 'auth/CurrentUser';
import { EventTrackingConstants } from 'constants/EventTrackingConstants';
import GroupKeyboardListener from 'groups/components/GroupKeyboardListener';
import RequireDesktop from 'lib/RequireDesktop';
import RequireSetup from 'lib/RequireSetup';
import RequireUser from 'lib/RequireUser';
import TriggerComposerButton from 'chat/components/TriggerComposerButton';
import chainOnEnter from 'components/lib/chainOnEnter';

type Props = {
  children?: React.Node,
};

class GroupsView extends React.Component<Props, void> {
  static childContextTypes = {
    eventContextName: PropTypes.string,
  };

  static onEnter = chainOnEnter([RequireUser, RequireSetup, RequireDesktop]);

  getChildContext() {
    return {
      eventContextName: EventTrackingConstants.UNIVERSAL_COMPOSER_CLASSES,
    };
  }

  displayUnsavedChangesDialog(): Promise<*> {
    return new Promise(resolve => {
      mountModal(
        <ConfirmDialog
          eventScreenName="GroupsView"
          actionButtonText={'Discard'}
          cancelButtonText={'Cancel'}
          size="small"
          title={'Are you sure you want to discard this announcement?'}
          onConfirm={resolve}
        />,
        this
      );
    });
  }

  renderComposeButton() {
    if (!CurrentUser.getUser().canChat()) {
      return null;
    }
    return (
      <TriggerComposerButton
        full
        eventScreenName="groups_view"
        eventElementName="new_message_button"
      />
    );
  }

  renderHeader() {
    return (
      <AppLayoutContentViewHeader title="Classes">
        {this.renderComposeButton()}
      </AppLayoutContentViewHeader>
    );
  }

  render() {
    return (
      <AppLayoutContentView header={this.renderHeader()} className="GroupsView">
        {this.props.children}
        <GroupKeyboardListener />
      </AppLayoutContentView>
    );
  }
}

export default GroupsView;
